import React, { useState } from 'react';
import { Typography, Modal, Button } from 'antd';

const { Paragraph, Text } = Typography;

const DOWNLOAD_TEMPLATE_PHRASE = 'Click here to download the proper template';
const HERE_OFFSET = DOWNLOAD_TEMPLATE_PHRASE.indexOf('here');

function renderErrorMessage(message, onDownloadTemplate) {
  if (
    typeof message === 'string' &&
    message.includes(DOWNLOAD_TEMPLATE_PHRASE) &&
    onDownloadTemplate
  ) {
    const phraseIndex = message.indexOf(DOWNLOAD_TEMPLATE_PHRASE);
    const before = message.slice(0, phraseIndex);
    const after = message.slice(phraseIndex + DOWNLOAD_TEMPLATE_PHRASE.length);
    const beforeHere = DOWNLOAD_TEMPLATE_PHRASE.slice(0, HERE_OFFSET);
    const afterHere = DOWNLOAD_TEMPLATE_PHRASE.slice(HERE_OFFSET + 'here'.length);

    return (
      <>
        {before}
        {beforeHere}
        <Text
          style={styles.downloadLink}
          onClick={(e) => {
            e.stopPropagation();
            onDownloadTemplate();
          }}
        >
          here
        </Text>
        {afterHere}
        {after}
      </>
    );
  }

  return message;
}

function ErrorModal({ errorList, isVisible, title, onDownloadTemplate }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {errorList?.length !== 0 && (
        <div>
          <Paragraph
            ellipsis={{
              rows: 3,
            }}
            type='danger'
          >
            {renderErrorMessage(errorList?.[0], onDownloadTemplate)}
          </Paragraph>
          {errorList?.length > 1 && (
            <Text style={styles.showMore} onClick={() => setShowModal(true)}>
              Show more
            </Text>
          )}
        </div>
      )}
      {showModal && (
        <Modal
          title={title}
          centered
          visible={showModal}
          onOk={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          width={1000}
          destroyOnClose
          footer={
            <Button key='ok' type='primary' onClick={() => setShowModal(false)}>
              Ok
            </Button>
          }
          bodyStyle={{ height: '70vh', overflow: 'auto' }}
        >
          <ul>
            {errorList?.map((message) => (
              <li>
                <Paragraph type='danger' copyable={{ tooltips: false }}>
                  {renderErrorMessage(message, onDownloadTemplate)}
                </Paragraph>
              </li>
            ))}
          </ul>
        </Modal>
      )}
    </>
  );
}

export default ErrorModal;

const styles = {
  showMore: {
    cursor: 'pointer',
    color: '#1890ff',
    float: 'right',
  },
  downloadLink: {
    cursor: 'pointer',
    color: '#1890ff',
    textDecoration: 'underline',
  },
};
